import "../bliss/BlissPurchaseJourney.css";
import { useState } from "react";
import type { VendorOrder } from "../../../shared/beachBumzOrders";
export default function VendorReleaseControls({
  order,
  onSave,
}: {
  order: VendorOrder;
  onSave: (fields: Record<string, unknown>) => Promise<void>;
}) {
  const [amount, setAmount] = useState(
      order.wholesalePending ? "" : String(order.amountUsd),
    ),
    [dimensions, setDimensions] = useState(!!order.productionReleased),
    [scope, setScope] = useState(!!order.productionReleased),
    [review, setReview] = useState(!!order.reviewCompleted),
    [release, setRelease] = useState(!!order.productionReleased),
    [date, setDate] = useState(order.installationConfirmed || ""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  return (
    <section className="bbv-card">
      <h2>Bliss production approval</h2>
      <p>
        Confirm the supplier agreement and customer-approved specifications
        before authorizing fabrication.
      </p>
      <form
        className="bbv-release-form"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError("");
          try {
            await onSave({
              amountUsd: Number(amount),
              dimensionsApproved: dimensions,
              scopeApproved: scope,
              reviewCompleted: review,
              productionReleased: release,
              installationConfirmed: date,
            });
          } catch (e) {
            setError((e as Error).message);
          } finally {
            setBusy(false);
          }
        }}
      >
        <label>
          Agreed wholesale amount (USD)
          <input
            required
            type="number"
            min="0.01"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </label>
        <label>
          <input
            type="checkbox"
            checked={dimensions}
            onChange={(e) => setDimensions(e.target.checked)}
          />{" "}
          Room measurements and clearances approved
        </label>
        <label>
          <input
            type="checkbox"
            checked={scope}
            onChange={(e) => setScope(e.target.checked)}
          />{" "}
          Purchased scope and specifications approved
        </label>
        {order.reviewRequired && (
          <label>
            <input
              type="checkbox"
              checked={review}
              onChange={(e) => setReview(e.target.checked)}
            />{" "}
            Paid Room Review completed
          </label>
        )}
        <label>
          <input
            type="checkbox"
            checked={release}
            onChange={(e) => setRelease(e.target.checked)}
          />{" "}
          Release to production
        </label>
        <label>
          Confirmed installation date
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </label>
        {error && <p role="alert">{error}</p>}
        <button className="bbv-primary" disabled={busy}>
          {busy ? "Saving…" : "Save Bliss approval"}
        </button>
      </form>
    </section>
  );
}
